"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeDtaasContext = void 0;
/**
 * A function that normalizes the context before sending to DTaaS.
 * Any string is lower-cased. Any other type, is being passthrough as-is
 * @param context an object of type { [key: string]: any }
 * @returns a normalized context
 */
const normalizeDtaasContext = (context) => {
    return Object.keys(context).reduce((acc, key) => {
        const value = context[key];
        acc[key] = typeof value === "string" ? value.toLowerCase() : value;
        return acc;
    }, {});
};
exports.normalizeDtaasContext = normalizeDtaasContext;
//# sourceMappingURL=dtaasUtils.js.map